export function storeFilteredEvent(event, guestId, key = "eventData") {
  if (!event || !guestId) return;

  const eventToStore = { ...event };

  if (Array.isArray(eventToStore.invitations)) {
    eventToStore.invitations = eventToStore.invitations.filter(
      (invite) => invite.guestId?._id === guestId
    );
  }

  if (Array.isArray(eventToStore.checkIns)) {
    eventToStore.checkIns = eventToStore.checkIns
      .map((check) => {
        const filteredGuests = (check.checkedInGuests || []).filter(
          (guest) => guest.guestId === guestId
        );
        return {
          ...check,
          checkedInGuests: filteredGuests,
        };
      })
      .filter((check) => (check.checkedInGuests || []).length > 0);
  }

  if (Array.isArray(eventToStore.attireRefunds)) {
    eventToStore.attireRefunds = eventToStore.attireRefunds.filter(
      (refund) => refund?.guestId === guestId
    );
  }

  localStorage.setItem(key, JSON.stringify(eventToStore));
}
